var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupfleet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2502 25.421V9.2904C41.2502 8.08742 40.2654 7.11182 39.051 7.11182H36.0693V27.8269H38.8215C40.1622 27.8269 41.2502 26.7501 41.2502 25.421Z",
    fill: "#007298"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1797 2.17859C36.1797 0.975606 35.196 0 33.9806 0H8.17763C6.96332 0 5.97852 0.975606 5.97852 2.17859V25.6743C5.97852 26.8772 6.96332 27.8529 8.17763 27.8529H39.0988C37.4861 27.8378 36.1868 26.5387 36.1858 24.9411L36.1797 2.17859Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M30.8307 9.71804C30.7397 9.71804 30.6466 9.73107 30.5526 9.75611L29.497 10.0446L28.401 7.40023C28.0906 6.65099 27.1725 6.04199 26.3556 6.04199H16.1011C15.2831 6.04199 14.3661 6.65099 14.0557 7.40023L12.9617 10.0406L11.9192 9.75611C11.8262 9.73107 11.7322 9.71804 11.6412 9.71804C11.1427 9.71804 10.7808 10.0957 10.7808 10.6155V11.2315C10.7808 11.8385 11.2792 12.3323 11.8919 12.3323H12.0113L11.8343 12.7591C11.5462 13.4552 11.3116 14.6331 11.3116 15.3854V20.639C11.3116 21.246 11.8101 21.7398 12.4228 21.7398H13.8737C14.4864 21.7398 14.9849 21.246 14.9849 20.639V19.3269H27.4708V20.639C27.4708 21.246 27.9693 21.7398 28.582 21.7398H30.0329C30.6456 21.7398 31.1441 21.246 31.1441 20.639V15.3854C31.1441 14.6331 30.9095 13.4552 30.6214 12.7591L30.4444 12.3323H30.5789C31.1916 12.3323 31.6901 11.8385 31.6901 11.2315V10.6155C31.6911 10.0957 31.3291 9.71804 30.8307 9.71804ZM13.7584 11.7354L15.2356 8.16949C15.4793 8.00723 15.6613 7.88703 15.905 7.72476H26.5517C26.7954 7.88703 26.9774 8.00723 27.2211 8.16949L28.6983 11.7354C28.8843 12.1831 28.6356 12.5497 28.1472 12.5497H14.3105C13.8211 12.5497 13.5734 12.1831 13.7584 11.7354ZM17.459 16.7937C17.459 17.0361 17.2588 17.2344 17.0141 17.2344H13.8656C13.6209 17.2344 13.4207 17.0361 13.4207 16.7937V15.2962C13.4207 15.0538 13.6209 14.8555 13.8656 14.8555H17.0141C17.2588 14.8555 17.459 15.0538 17.459 15.2962V16.7937ZM29.0067 16.7937C29.0067 17.0361 28.8065 17.2344 28.5618 17.2344H25.4132C25.1686 17.2344 24.9684 17.0361 24.9684 16.7937V15.2962C24.9684 15.0538 25.1686 14.8555 25.4132 14.8555H28.5618C28.8065 14.8555 29.0067 15.0538 29.0067 15.2962V16.7937Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11399 27.9391C6.93607 27.9391 5.98059 26.9925 5.98059 25.8256V17.0161C2.52873 17.9827 0 21.1259 0 24.855C0 29.3534 3.68137 32.9994 8.22117 32.9994C11.6599 32.9994 14.6052 30.908 15.8316 27.9391H11.0047H8.11399V27.9391Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3254 20.7531C13.8998 18.3351 11.2527 16.7114 8.22251 16.7114C7.44599 16.7114 6.69374 16.8186 5.98193 17.0179V20.7541V25.8294C5.98294 26.9954 6.9364 27.9399 8.11331 27.9409H15.833C16.2263 26.9894 16.4437 25.9486 16.4437 24.8568C16.4437 23.3594 16.0362 21.9581 15.3254 20.7531Z",
    fill: "#007298"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03362 20.8848L4.50391 22.4383V24.7692C4.50391 26.7955 5.82944 28.6926 7.66659 29.3237L8.18123 20.9499L8.03362 20.8848Z",
    fill: "#FAFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18213 20.9487L7.66748 29.3225C7.7878 29.3636 7.90913 29.3997 8.03349 29.4297C10.0587 28.9379 11.5632 26.9256 11.5632 24.768V22.4372L8.18213 20.9487Z",
    fill: "#8CF2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03928 29.6541L7.97963 29.6391C5.85736 29.1243 4.25781 27.0158 4.25781 24.734V22.2399L8.0403 20.5752L11.8228 22.2399V24.734C11.8228 27.0158 10.2222 29.1243 8.10096 29.6391L8.03928 29.6541ZM4.76235 22.5665V24.735C4.76235 26.7704 6.16675 28.6515 8.03928 29.1383C9.91182 28.6515 11.3162 26.7704 11.3162 24.735V22.5665L8.03928 21.1241L4.76235 22.5665Z",
    fill: "#1BB3CC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.5274,
    y1: 35.9447,
    x2: 19.4359,
    y2: -2.51687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6569,
    stopColor: "#00CAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -9.72945,
    y1: 30.6131,
    x2: 34.7555,
    y2: 16.0727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6569,
    stopColor: "#00CAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupfleet);
export default __webpack_public_path__ + "static/media/Groupfleet.02e4f290f5d3aff6d4dcd1d2c9da7861.svg";
export { ForwardRef as ReactComponent };